import { useEffect, useState, useMemo, useRef } from 'react';
import { fields, initialValues, schema, additionalState, parseData, blockFields, blockIntitialValues } from "./config";

import EditForm from '../../utils/utilities/EditForm';

import Sidebar from './Components/Sidebar';

import useIsMobile from '../../hooks/useIsMobile';

import { useQuery } from '@tanstack/react-query';

import { DateTime } from "luxon";

import { getStylists } from '../Stylists/apiService';

import { ScheduleTypesContext} from '../../contexts/ScheduleTypes';

import useFollowUpSnackbarStore from '../../store/repair_follow_up';

const { v4: uuidv4 } = require('uuid');


const EditSchedule = ({id, dialog, event = {}}) => {

  let { isMobile } = useIsMobile();

  let initService = {
    name: "",
    duration_in_minutes: "", 
    service_price: "", 
    wig_id: "", 
    wig_source: "inventory",
    test_field: "test",
    key: 0.45643
  }

  const [ initValues, setInitValues ] = useState({
    ...initialValues,
    services: [initService],
    group_id: uuidv4()
  });
  const [ formFields, setFormFields ] = useState([...fields.map(field => ({...field}))]);

  const [appointmentType, setAppointmentType] = useState('customer');

  const prevAppointmentTypeRef = useRef(appointmentType);

  let sidebar = useMemo(() => (isMobile || appointmentType !== 'customer' ? null : <Sidebar />), [isMobile, appointmentType]);

  // follow up repair check
  const fu_open = useFollowUpSnackbarStore(state => state.open);
  const fu_customer_id = useFollowUpSnackbarStore(state => state.customer_id);
  const fu_customer_name = useFollowUpSnackbarStore(state => state.customer_name);
  const fu_customer_phone = useFollowUpSnackbarStore(state => state.customer_phone);

  const { data: stylists } = useQuery({
    queryKey: ["stylists"],
    queryFn: getStylists,
  });

  // useEffect(() => {
  //   if (event && event.timestamp && !event.appointment_id) {
  //     let newDate = DateTime.fromJSDate(event.timestamp);
  //     let stylist_id = event.stylist?.toString()
  //     setInitValues(ov => {
  //       let service = ov.services[0];
  //       if (event.stylist) {
  //         service.stylist_id = event.stylist?.toString()
  //       }
  //       return {
  //         ...ov,
  //         appointment_date: newDate,
  //         start_time: newDate,
  //         stylist_id: event.stylist?.toString(),
  //         services: [service]
  //       }
  //     })
  //   }
  // }, [event])
  useEffect(() => {
    // if (event && event.timestamp && !event.appointment_id) {
      let newDate = DateTime.fromJSDate(event?.timestamp);
      let stylist_id = event?.stylist?.toString() || ""

      if (appointmentType === 'customer') {
        setInitValues(ov => {
          let service = initService;
          if (event?.stylist) {
            service.stylist_id = stylist_id
          }
          return {
            ...initialValues,
            appointment_date: event?.timestamp ? newDate : initialValues.appointment_date,
            start_time: event?.timestamp ? newDate : initialValues.start_time,
            stylist_id,
            services: [service],
            group_id: ov.group_id
          }
        })
      } else if (appointmentType === 'personal_block') {
        setInitValues(ov => {
          return {
            ...blockIntitialValues, 
            appointment_date: event?.timestamp ? newDate : blockIntitialValues.appointment_date, 
            start_time: event?.timestamp ? newDate : blockIntitialValues.start_time, 
            end_time: event?.timestamp ? newDate : blockIntitialValues.end_time,
            stylist_id, 
            services: null,
            group_id: ov.group_id,
            recurrence_pattern: {
              ...blockIntitialValues.recurrence_pattern,
              start_date: event?.timestamp ? newDate : blockIntitialValues.recurrence_pattern.start_date,
              end_date: event?.timestamp ? newDate : blockIntitialValues.recurrence_pattern.end_date
            }
          }
        })
      }
    // }
  }, [event, appointmentType])

  useEffect(() => {
    if (fu_open) {
      setInitValues(ov => {
        return {
          ...ov,
          customer_id: fu_open ? fu_customer_id : "",
        }
      })
    }
  }, [fu_open])

  useEffect(() => {
    if (appointmentType !== prevAppointmentTypeRef.current) {
      if (appointmentType === 'customer') {
        setFormFields([...fields.map(field => ({...field}))])
      } else if (appointmentType === 'personal_block') {
        setFormFields([...blockFields.map(field => ({...field}))])
      }
      prevAppointmentTypeRef.current = appointmentType
    }
  }, [appointmentType])

  useEffect(() => {
    if (fu_open) {
      let updatedFields = formFields.map(field => {
        if (field.name === 'customer_id') {
         return {
           ...field,
           serverOptions: [{customer_id: fu_customer_id, full_name: fu_customer_name, mobile_phone: fu_customer_phone}]
         }
        }
        return field;
      })
      setFormFields(updatedFields);
     }
  }, [fu_open])

   const additionalButtons = [
    { text: "Update All Recurring Events", variant: "outlined", color: "secondary", queries: { edit_all: true }, is_visible: (values, id) => id && values.is_recurring && values.recurring_group_id ? true : false },
    { text: "Update Event", variant: "contained", color: "primary", queries: { edit_all: true }, is_visible: (values, id) => id && values.is_recurring && !values.recurring_group_id ? true : false },
  ]

  return (
    <ScheduleTypesContext.Provider value={{appointmentType, setAppointmentType, stylists}}>
      <EditForm title={"Schedule"} initialValues={initValues} fields={formFields} schema={schema} url={"appointments"} additionalState={appointmentType === 'customer' ? additionalState : null} sidebar={sidebar} dialog={dialog} edit_id={event?.appointment_id ? event.appointment_id : null} parseData={parseData} additionalButtons={additionalButtons} submitButton={(values, id) => id && values.is_recurring && !values.recurring_group_id ? true : false}
      >
        
      </EditForm>
     </ScheduleTypesContext.Provider>
  );
};

export default EditSchedule;